import {UserId} from '../../../shared/models/user';


export interface Message<T = any> {
  _ws: Properties;
  payload: T;
}


export const FuncAuthenticate = 'authenticate';
export const FuncConvoNewStep = 'convo-new-step';
export const FuncConvoNewStepGroup = 'convo-new-step-group';
export const FuncConvoStatus = 'convo-status';
export const FuncConvoUpdate = 'convo-update';
export const FuncConvoStepDeletion = 'convo-step-deletion';
export const FuncConvoStepGroupAddition = 'convo-step-group-addition';
export const FuncConvoStepRegen = 'convo-step-regen';
export const FuncConvoStepUpdate = 'convo-step-update';
export const FuncError = 'error';

export type FuncName =
  | typeof FuncAuthenticate
  | typeof FuncConvoNewStep
  | typeof FuncConvoNewStepGroup
  | typeof FuncConvoStatus
  | typeof FuncConvoUpdate
  | typeof FuncConvoStepDeletion
  | typeof FuncConvoStepGroupAddition
  | typeof FuncConvoStepRegen
  | typeof FuncConvoStepUpdate
  | typeof FuncError;


export interface Properties {
  funcName: FuncName;
}


export interface Authenticate {
  userId: UserId;
  token: string;
}


export function CreateMessage<T>(func: FuncName, payload: T): Message<T> {
  return {
    _ws: {
      funcName: func,
    },
    payload: payload,
  };
}
